export default "__VITE_ASSET__C8AVIn54__"